import React from 'react'
import { ImSpinner9 } from 'react-icons/im'

export default function SpinnerLoading() {
  return (
    <>
      <ImSpinner9
        className="me-2 "
        style={{ animation: '0.75s linear infinite spinner-border' }}
      />
      <span className="fw-light">Loading...</span>
    </>
  )
}
